export default __webpack_public_path__ + "static/cloud-cb81a9936e07dc9a34af768dd021033f.jpg";